/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import SmallText from '../../../typography/SmallText'
import Avatar from '../../Avatar'
import styles, { mentionTheme } from './styles'

const MentionOption = ({ theme, selected, avatar, avatarTheme, avatarThemeModifier, avatarFallback, handle, name, onHover, onSelect }) => (
  <dd className={cx(styles.mention, selected && mentionTheme(theme))} onMouseOver={onHover} onClick={onSelect}>
    <Avatar
      url={avatar}
      themeModifier={avatarThemeModifier}
      name={name}
      theme={avatarTheme}
      size="extraSmall"
      fallback={avatarFallback}
      round
    />
    <div>
      <strong>
        <SmallText>{handle}</SmallText>
      </strong>
      <SmallText className={styles.name}>{name}</SmallText>
    </div>
  </dd>
)

MentionOption.propTypes = {
  selected: PropTypes.bool,
  avatar: PropTypes.string,
  avatarFallback: PropTypes.oneOf(['', 'icon', 'initials']),
  handle: PropTypes.string.isRequired,
  name: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'tertiary', 'info']),
  avatarTheme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'tertiary', 'info']),
  avatarThemeModifier: PropTypes.oneOf(['', 'light', 'dark']),
  onHover: PropTypes.func,
  onSelect: PropTypes.func,
}

MentionOption.defaultProps = {
  avatarFallback: 'initials',
  avatarTheme: 'primary',
  avatarThemeModifier: 'dark',
}

export default MentionOption
